// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"personal-module--pageContainer--2O4Wv","pageText":"personal-module--pageText--1eTQE"};